import React from "react";
import PropTypes from "prop-types";
import { useMediaQuery } from "react-responsive";
import RankingMobile from "./RankingMobile";
import RankingDesktop from "./RankingDesktop";

function Ranking({ app, config }) {
	const isMobile = useMediaQuery({ query: "(max-width: 980px)" });

	return isMobile ? (
		<RankingMobile app={app} config={config} />
	) : (
		<RankingDesktop app={app} config={config} />
	);
}

Ranking.defaultProps = {
	app: null,
	config: {},
};

Ranking.propTypes = {
	app: PropTypes.object,
	config: PropTypes.object,
};

export default Ranking;
